<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Nhập sim`" />
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-toolbar card color="white">
              <v-btn outline round color="primary" @click="pickFile" v-model="fileName">
                {{fileName}}
                <v-icon right>attach_file</v-icon>
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileUpload"
                accept=".xlsx, .xls, .csv"
                @change="onFilePicked"
              />
              <v-spacer></v-spacer>
              <v-btn
                flat
                round
                color="success"
                href="/static/Import_Sim_Template.xlsx"
                target="_blank"
              >
                Tải file mẫu
                <v-icon right>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <import-sim-table :isLoading="isLoading" :datasource="simViewModels" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isImporting">Nhập sim</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as Utils from '@/utils';
import XLSX from 'xlsx';
import AppBar from '@/components/appbar';
import ImportSimTable from './components/importlist';
import moment from 'moment';

export default {
  components: {
    ImportSimTable,
    AppBar
  },
  data () {
    return {
      fileName: 'Chọn file',
      simViewModels: [],
      isLoading: false,
      isImporting: false
    };
  },
  methods: {
    ...mapActions(['importSims']),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.parseExcelFileToJson(files[0]);
      }
    },
    parseExcelFileToJson (f) {
      this.isLoading = true;

      this.fileName = `Đã chọn: ${f.name}`;

      let reader = new FileReader();
      reader.readAsBinaryString(f);

      reader.onload = e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary'
        });
        let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let content = XLSX.utils.sheet_to_json(first_worksheet, {
          header: 1
        });

        this.simViewModels = [];

        content.map((item, index) => {
          if (index > 0) {
            let sim = {
              iccId:
                item[1] && item[1].startsWith(`'`)
                  ? item[1].substr(1)
                  : item[1],
              phone:
                item[2] && item[2].startsWith(`'`)
                  ? item[2].substr(1)
                  : item[2],
              telco: item[3],
              telcoActivationDate: item[4]
                ? moment(item[4])
                  .add(7, 'hours')
                  .valueOf()
                : null,
              prepaid: item[5] === 'TRUE' ? true : false,
              prepaidAmount: item[6],
              data: item[7],
              remark: item[8]
            };
            if (sim.iccId && sim.phone) {
              this.simViewModels.push(sim);
            }
          }
          return 0;
        });
        this.isLoading = false;
      };
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      if (this.simViewModels.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      this.isImporting = true;
      this.importSims(this.simViewModels)
        .then(res => {
          this.isImporting = false;
          if (res.success === res.total) {
            window.getApp.showMessage(`Nhập thành công ${res.total} sim`);
            window.history.back();
          } else {
            if (res.success > 0) {
              window.getApp.showMessage(`Nhập thành công ${res.success} sim`);
            }
            if (res.fail > 0) {
              this.simViewModels = res.failList;
              window.getApp.showMessage(
                `Nhập thất bại ${res.fail} sim`,
                'error'
              );
            }
          }
        })
        .catch(_ => {
          this.isImporting = false;
          window.getApp.showMessage(
            'Nhập sim thất bại, vui lòng thử lại',
            'error'
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/sim/import.vue